import React from 'react'
import { Link } from 'gatsby'
import logo from '../svgs/alesis-drums-logo.svg'

export default function BrandLogoLink(props) {
    return <Link to='/' {...props} >
        <img src={logo} alt='' height={28} />
    </Link>
}
